import React, { Suspense } from "react";

import ReactDOM from "react-dom/client";
import "@assets/styles/index.css";
import reportWebVitals from "@shared/utils/WebVitalsReporter";
import App from "@authien/App";
import { BrowserRouter } from "react-router-dom";

import "@i18n"

import { setupMutationObserverWrapper } from "@shared/utils/dom";
import { isChunkLoadError } from "@shared/utils/chunk-retry";

setupMutationObserverWrapper();

window.addEventListener('error', (event) => {
  if (event.error && isChunkLoadError(event.error)) {
    event.preventDefault();
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', (event) => {
  if (event.reason instanceof Error && isChunkLoadError(event.reason)) {
    event.preventDefault();
    window.location.reload();
  }
});

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <Suspense fallback={null}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </Suspense>
);

reportWebVitals();
